export const SET_GET_USER_INFO = 'SET_GET_USER_INFO';

export const SET_IS_EMAIL_REGISTER = 'SET_IS_EMAIL_REGISTER';
